module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page8",
      "title": "8"
    }
  }, [_c('div', {
    attrs: {
      "id": "acks"
    }
  }, [_c('h1', {
    staticClass: "acks-hed"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Thank you to my supportive family, including my amazing husband. You know there is no one else on earth I would rather share a “table for two” with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to everyone at Houghton Mifflin Harcourt for turning my cookbook dreams into reality. A special thank-you to Justin Schwartz. And thank you to my agent, Holly Schmidt, and Hollan Publishing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And most importantly, thank you to all my "), _c('a', {
    attrs: {
      "href": "http://HealthyHappyLife.com",
      "target": "_blank"
    }
  }, [_vm._v("HealthyHappyLife.com")]), _vm._v(" readers and "), _c('a', {
    attrs: {
      "href": "http://FindingVegan.com",
      "target": "_blank"
    }
  }, [_vm._v("FindingVegan.com")]), _vm._v(" fans. You are the reason I am able to do what I love for a living, creating recipes and sharing them with the world. The kindness and compassion I have received from my loyal blog readers is beyond priceless to me. Thank you. I cannot wait to continue to share my crazy, amazing, food-infused journey with you guys!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to YOU for buying this book. I want to wish you all the success in the world when it comes to your wellness goals. Believe in yourself, be kind to yourself, and you can do anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Love, light, and happy wishes to you all. Xo ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—Kathy")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a0d988","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/page008.vue
// module id = 72
// module chunks = 0